import { render } from "./CouponHolder.vue?vue&type=template&id=25a18f84&scoped=true"
import script from "./CouponHolder.vue?vue&type=script&lang=js"
export * from "./CouponHolder.vue?vue&type=script&lang=js"

import "./CouponHolder.vue?vue&type=style&index=0&id=25a18f84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-25a18f84"

export default script